import React from 'react'
import Translate from 'App/i18n'
import translate from 'App/i18n/translate'
import {Form, Field} from 'simple-react-form'
import Text from './Text'
import Button from 'orionsoft-parts/lib/components/Button'
import styles from './styles.css'
import autobind from 'autobind-decorator'
import {forgotPassword} from 'meteor-apollo-accounts'
import {gql, withApollo} from 'react-apollo'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'

@withGraphQL(gql`
  query me {
    me {
      _id
      email
    }
  }
`)
@withApollo
export default class Forgot extends React.Component {
  state = {}

  static propTypes = {
    setLoading: PropTypes.func,
    isLoading: PropTypes.bool,
    setError: PropTypes.func,
    client: PropTypes.object,
    me: PropTypes.object
  }

  @autobind
  async send() {
    if (!this.canSend()) return
    this.props.setLoading(true)
    this.props.setError(null)
    try {
      //console.log("State", this.state);
      //console.log("Client", this.props.client);
      await forgotPassword(this.state, this.props.client)
      this.setState({isReady: true})
      this.props.setLoading(false)
    } catch (e) {
      this.setState({errorMessage: "No ha sido posible resetear la contraseña"})
      this.props.setLoading(false)
    }
  }

  canSend() {
    return this.state.email
  }

  renderButtons() {
    return (
      <div className={styles.buttonsContainer}>
        <Button
          primary
          loading={this.props.isLoading}
          disabled={!this.canSend()}
          onClick={this.send}
        >
          <Translate tr="auth.forgot.resetPassword" />
        </Button>
      </div>
    )
  }

  renderReady() {
    return (
      <div>
        <Translate tr="auth.forgot.ready" />
      </div>
    )
  }

  render() {
    if(this.props.me){
      console.log("Hay me", this.props.usersData);
      this.props.router.push('/')
    } else {
      console.log("NO Hay me", this.props.me);
    }

    let copyEmail = localStorage.getItem('copyText')
    if(copyEmail){
      this.state.email = copyEmail
      localStorage.removeItem('copyText')
    } 
    if (this.state.isReady){
      
      setTimeout(() => {
          window.location.href='../'
        }, 3200
      );  
      return this.renderReady()
    } 
    return (
      <div>
        
        <div className='center-align'>Ingrese el correo electrónico de su cuenta en tuFirma.digital</div><br/>
        <div className={styles.serverError}>{this.state.errorMessage}</div><br/>
        <Form state={this.state} onChange={changes => this.setState(changes)} onSubmit={this.send}>
          <Field
            fieldName="email"
            type={Text}
            fieldType="email"
            placeholder={translate('auth.pages.email')}
          />
        </Form>
        {this.renderButtons()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/Forgot.js